import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { assurances, checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="bg-slate-900/60 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-130" data-mp="1ja0dw0krprkr">
      <div className="mx-auto max-w-3xl px-4" data-id="element-131" data-mp="1n9r1xwiwttll">
        <SectionHeading id="pricing-title" data-id="element-132" data-mp="1ncwujlqqzdm2">Scegli la tua <span className="text-sky-400" data-id="element-133" data-mp="1s8lrrifaoif7">opzione</span></SectionHeading>

        <article id="offerta" className="mt-10 scroll-mt-6 overflow-hidden rounded-3xl border-2 border-amber-400 bg-slate-950 shadow-2xl" data-id="element-134" data-mp="1x86u82tob8wo">
          <div className="border-b border-amber-400/30 bg-slate-900 px-6 py-4 sm:px-10" data-id="element-135" data-mp="227b1up0y8ykw">
            <span className="inline-flex items-center gap-2 rounded-full border border-sky-400/50 bg-sky-400/10 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-white" data-id="element-136" data-mp="2w0i91sygo3b">
              <AwardIcon className="h-3.5 w-3.5 text-amber-400" aria-hidden="true" data-id="element-137" data-mp="1mhq0kagbnggu" /> Offerta principale
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-138" data-mp="1hnv92kuh5x77">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-139" data-mp="1cqbxjsp5vyiy">
              <div data-id="element-140" data-mp="17saeh7rqjz7h">
                <h3 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-3xl" data-id="element-141" data-mp="17stlvujrf579">{productShortName}</h3>
                <p className="mt-2 text-sm text-slate-300" data-id="element-142" data-mp="25dg4423wkkwu">
                  Tutti i {totalVolumes} volumi + {totalBonuses} bonus esclusivi
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-143" data-mp="1vfryui8o7v0f">
                <span className="text-sm text-slate-300" data-id="element-144" data-mp="1rgar1i5ruls3">
                  Prezzo normale: <span className="line-through decoration-amber-400 decoration-2" data-id="element-145" data-mp="1ri42rbv8rw6y">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-146" data-mp="g02wa2wl0eqz">Oggi:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold leading-none tracking-tight text-amber-400 sm:text-6xl" data-id="element-147" data-mp="hhi237p7gmge">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-148" data-mp="7ju5sdbyb6w4">
              Sì, voglio l&apos;Edizione Docenti
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-149" data-mp="ckhx7043dpqv">
              {assurances.map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-150" data-mp="3j1wjk32x1zu">
                  <CheckCircle2Icon className="h-4 w-4 text-sky-400" aria-hidden="true" data-id="element-151" data-mp="3kz08rbt8rnf8" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}